// imports
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Header from '../../header';
import { ROUTES } from '../../../constants';
import { ICON, IMAGE } from '../../../assets';
import { IActionItem } from '../../../common/types';
import { Nav, OffCanvas } from '../../../atoms/nav';
import PrimaryButton from '../../../atoms/button/primary';
import AccountDropdown from '../../../atoms/dropdown/account';
import { useConnection } from '../../../repositories/web3/session';

// interfaces / types / consts
interface Props { navItems?: IActionItem[] }

// exports
export default function AccountHeader(props: Props): JSX.Element {
  const { navItems } = props;
  // hooks configuration
  const navigate = useNavigate();
  const { isConnected } = useConnection();
  return (
    <Header content={(
      <>
        <OffCanvas navItems={navItems} />
        <div className="logo logo-light">
          <Link to={ROUTES.HOME}>
            <img src={IMAGE.HOME_LOGO_GENESIS} alt="logo" />
          </Link>
        </div>
        <Nav navItems={navItems} />
        <div className="right-section">
          <PrimaryButton
            text="World Map"
            leftIcon={ICON.GLOBE}
            className="success play"
            disabled={!isConnected}
            onClick={() => navigate(ROUTES.GAME)}
          />
          <AccountDropdown />
        </div>
      </>
    )}
    />
  );
}

// default props
AccountHeader.defaultProps = { navItems: [] };
